import React, { useMemo } from "react"

const ORBIT_COUNT = 7
const TRAIL_COUNT = 5

/**
 * Activities wallpaper — chronograph field.
 * Pure geometry only (no text, no icons). Ambient animation only — no pointer effects.
 */
export default function ActivitiesScene({ layerRef }) {
  const orbits = useMemo(
    () =>
      Array.from({ length: ORBIT_COUNT }, (_, i) => ({
        i,
        angle: (360 / ORBIT_COUNT) * i,
        radius: 28 + (i % 3) * 10,
        delay: `${i * 0.4}s`,
        size: 0.45 + (i % 3) * 0.15,
      })),
    []
  )

  const trails = useMemo(
    () =>
      Array.from({ length: TRAIL_COUNT }, (_, i) => ({
        i,
        top: `${18 + i * 14}%`,
        delay: `${i * 0.7}s`,
        dur: `${5.5 + i * 0.6}s`,
      })),
    []
  )

  return (
    <div
      ref={layerRef}
      className="activities-wallpaper fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      aria-hidden
    >
      <div className="activities-chrono-glow activities-chrono-glow--a" />
      <div className="activities-chrono-glow activities-chrono-glow--b" />

      <div className="activities-energy-field">
        <span className="activities-energy-sheet activities-energy-sheet--1" />
        <span className="activities-energy-sheet activities-energy-sheet--2" />
        <span className="activities-energy-sheet activities-energy-sheet--3 hidden sm:block" />
      </div>

      <div className="activities-trails hidden sm:block">
        {trails.map((t) => (
          <span
            key={t.i}
            className="activities-trail"
            style={{
              top: t.top,
              animationDelay: t.delay,
              animationDuration: t.dur,
            }}
          />
        ))}
      </div>

      <div className="activities-orbit-cluster">
        <span className="activities-orbit-ring activities-orbit-ring--outer" />
        <span className="activities-orbit-ring activities-orbit-ring--mid hidden sm:block" />
        <span className="activities-orbit-ring activities-orbit-ring--inner" />
        <span className="activities-orbit-core" />
        {orbits.map((o) => (
          <span
            key={o.i}
            className={`activities-orbit-node ${o.i > 4 ? "hidden md:block" : ""}`}
            style={{
              "--orbit-angle": `${o.angle}deg`,
              "--orbit-radius": `${o.radius}%`,
              "--node-size": `${o.size}rem`,
              animationDelay: o.delay,
            }}
          />
        ))}
      </div>

      <span className="activities-chevron activities-chevron--tl" />
      <span className="activities-chevron activities-chevron--tr" />
      <span className="activities-chevron activities-chevron--bl hidden sm:block" />
      <span className="activities-chevron activities-chevron--br hidden sm:block" />
    </div>
  )
}
